import { Envelope } from '@/store/modules/envelopes/models/Envelope';

const Envelopes = Envelope.array();

export default Envelopes;
